import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "workflow-graph-view" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Background = _resolveComponent("Background")!
  const _component_Controls = _resolveComponent("Controls")!
  const _component_WorkflowNode = _resolveComponent("WorkflowNode")!
  const _component_VueFlow = _resolveComponent("VueFlow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VueFlow, {
      nodes: _ctx.nodes,
      edges: _ctx.edges,
      "nodes-draggable": false,
      "nodes-connectable": false,
      "elements-selectable": false,
      "pan-on-drag": true,
      "fit-view-on-init": "",
      class: "vue-flow-container"
    }, {
      "node-mainAgent": _withCtx((props) => [
        _createVNode(_component_WorkflowNode, _normalizeProps(_guardReactiveProps(props)), null, 16)
      ]),
      "node-helperAgent": _withCtx((props) => [
        _createVNode(_component_WorkflowNode, _normalizeProps(_guardReactiveProps(props)), null, 16)
      ]),
      "node-tool": _withCtx((props) => [
        _createVNode(_component_WorkflowNode, _normalizeProps(_guardReactiveProps(props)), null, 16)
      ]),
      "node-embeddingCollection": _withCtx((props) => [
        _createVNode(_component_WorkflowNode, _normalizeProps(_guardReactiveProps(props)), null, 16)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Background, {
          "pattern-color": "rgba(var(--v-theme-primary), 0.12)",
          gap: 24
        }),
        _createVNode(_component_Controls, {
          position: "bottom-right",
          "show-interactive": false
        })
      ]),
      _: 1
    }, 8, ["nodes", "edges"])
  ]))
}